import {
  Icon,
  UilBox,
  UilCalculator,
  UilCog,
  UilEuro,
  UilFile,
  UilFilterSlash,
  UilInfo,
  UilUsdCircle,
  UilUser,
  UilQuestionCircle,
  UilUserCircle
} from '@iconscout/react-unicons';
import {
  ADMIN_LEVEL,
  APPLICATION,
  APPLICATION_TYPE_OPTION,
  FEDERAL_STATE,
  GROUP_MANAGEMENT,
  HEALTH_APPLICATION_CALCULATION,
  PRODUCT,
  ROLE,
  SUBSIDY_CALCULATION_WITHOUT_INCOME,
  SUBSIDY_CALCULATION_WITH_INCOME,
  SUBSIDY_CALCULATION_WITH_INCOME_CALCULATOR,
  TOOLTIP,
  USER
} from 'constant/RoutesUrls';
import { t } from 'i18next';
import { modules } from 'utils/enums/misc';
import { capitalizeFirstLetter } from 'utils/helpers';
import { ReactComponent as UilUserCog } from 'assets/img/icons/user-cog.svg';

type iconSet = 'font-awesome' | 'feather' | 'unicons' | 'svg';

export interface Route {
  name: string;
  icon?: any;
  iconSet?: iconSet;
  pages?: Route[];
  path?: string;
  pathName?: string;
  flat?: boolean;
  topNavIcon?: string;
  dropdownInside?: boolean;
  active?: boolean;
  new?: boolean;
  hasNew?: boolean;
  notShowInProd?: boolean;
}

export interface RouteItems {
  label: string;
  horizontalNavLabel?: string;
  icon: any;
  labelDisabled?: boolean;
  pages: Route[];
  megaMenu?: boolean;
  active?: boolean;
  hasPages: boolean;
  path: string | null;
  permission: string;
  iconSet?: iconSet;
  notShowInProd?: boolean;
}

export const routes: RouteItems[] = [
  {
    label: t('header.text.text_2'),
    icon: UilUser,
    pages: [],
    hasPages: false,
    active: true,
    path: USER,
    permission: modules.USERS.view
  },
  {
    label: t('header.text.text_3'),
    icon: UilBox,
    pages: [],
    hasPages: false,
    active: false,
    path: PRODUCT,
    permission: modules.PRODUCT.view
  },
  {
    label: t('header.text.text_5'),
    icon: UilFile,
    pages: [],
    hasPages: false,
    active: false,
    path: APPLICATION,
    permission: modules.APPLICATION.view
  },
  {
    label: t('header.text.text_6'),
    icon: UilCog,
    pages: [],
    hasPages: false,
    active: false,
    path: APPLICATION_TYPE_OPTION,
    permission: modules.APPLICATION_REQUEST_OPTION.view
  },
  {
    label: t('header.text.text_9'),
    icon: UilCalculator,
    pages: [
      {
        name: capitalizeFirstLetter(t('header.text.text_10')),
        dropdownInside: true,
        path: SUBSIDY_CALCULATION_WITH_INCOME,
        icon: UilEuro,
        iconSet: 'unicons'
      },
      {
        name: capitalizeFirstLetter(t('header.text.text_11')),
        dropdownInside: true,
        path: SUBSIDY_CALCULATION_WITHOUT_INCOME,
        icon: UilFilterSlash,
        iconSet: 'unicons'
      },
      {
        name: capitalizeFirstLetter(t('header.text.text_12')),
        dropdownInside: true,
        path: SUBSIDY_CALCULATION_WITH_INCOME_CALCULATOR,
        icon: UilUsdCircle,
        iconSet: 'unicons'
      },
      {
        name: capitalizeFirstLetter(t('header.text.text_19')),
        dropdownInside: true,
        path: HEALTH_APPLICATION_CALCULATION,
        icon: UilUsdCircle,
        iconSet: 'unicons'
      }
    ],
    hasPages: true,
    active: true,
    path: null,
    horizontalNavLabel: t('header.text.text_9'),
    permission: modules.CONFIGURATION.view
  },
  {
    label: t('header.text.text_7'),
    icon: UilInfo,
    pages: [],
    hasPages: false,
    active: false,
    path: TOOLTIP,
    permission: modules.TOOLTIP.view
  },
  {
    label: t('header.text.text_8'),
    icon: UilUserCircle,
    pages: [],
    hasPages: false,
    active: false,
    path: ROLE,
    permission: modules.ROLE.view
  },
  {
    label: t('header.text.text_14'),
    icon: UilUserCog,
    pages: [
      {
        name: t('admin_level.title'),
        dropdownInside: true,
        path: ADMIN_LEVEL,
        icon: UilCog,
        iconSet: 'unicons',
        // notShowInProd: true
      },
      {
        name: capitalizeFirstLetter(t('header.text.text_13')),
        dropdownInside: true,
        path: GROUP_MANAGEMENT,
        icon: UilFile,
        iconSet: 'unicons',
        // notShowInProd: true
      },
      {
        name: capitalizeFirstLetter(t('federal_state.title')),
        dropdownInside: true,
        path: FEDERAL_STATE,
        icon: UilCog,
        iconSet: 'unicons',
        // notShowInProd: true
      }
    ],
    hasPages: true,
    active: true,
    path: null,
    horizontalNavLabel: t('header.text.text_14'),
    permission: modules.ADMIN_LEVEL.view,
    iconSet: 'svg',
    // notShowInProd: true
  }
  // {
  //   label: t('header.text.text_15'),
  //   icon: UilQuestionCircle,
  //   pages: [],
  //   hasPages: false,
  //   active: false,
  //   horizontalNavLabel: t('header.text.text_15'),
  //   path: FAQ,
  //   permission: '',
  //   notShowInProd: false
  // }
];
